import styled from 'styled-components';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

export const Link = styled.a`
  font-weight: 500;
`;

export const Title = styled(Heading).attrs({ size: 'lg' })`
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const Description = styled(Text)``;
